const initialState = {
    deleting: false,
    deleteConfirmation: null,
    deleteResourceId: null,
    lastResourceIdDeleted: null,
    additionalResourceIds: null,
    additionalData: null,
    postDeleteActions: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./public/pages/DeleteConfirmation/initialState.js